<template>
  <button
    type="button"
    class="button is-small is-info is-outlined"
    :class="{ 'is-loading': loading }"
    :disabled="!offerId || loading"
    data-test="greetings-suggestion-button"
    @click.stop="fetchSuggestion"
  >הצעת פתיח לפי כישורים</button>
</template>

<script>
// VA2 - fetch a skills-based opening line for the CV email; the parent appends
// it to the greetings textarea for the recruiter to edit. Nothing is sent.
export default {
  name: 'GreetingsSuggestionButton',
  props: {
    offerId: { type: Number, default: null }
  },
  data () {
    return { loading: false }
  },
  methods: {
    async fetchSuggestion () {
      if (!this.offerId || this.loading) return
      this.loading = true
      try {
        const res = await this.$network_utils.getCvGreetingsSuggestion({ offer_id: this.offerId })
        const text = res && typeof res.text === 'string' ? res.text.trim() : ''
        if (text) {
          this.$emit('suggest', text)
        } else {
          this.$utils.emit('show_toast', { text: 'אין הצעת פתיח למשרה הזו' })
        }
      } catch (e) {
        this.$utils.emit('show_toast', { text: 'לא הצלחנו להביא הצעת פתיח - נסו שוב' })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
